import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ['source', 'button']
  static values = { successContent: String }

  connect() {}

  copy() {
    navigator.clipboard.writeText(this.sourceTarget.value).then(() => this.copied())

  }

  copied() {
    this.buttonTarget.innerHTML = this.successContentValue
  }
}
